export const FIRESTORE_MAX_BATCH_SIZE = 250
